<template>
  <div v-if="isLoading" class="loader">
    <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
  </div>
</template>

<script>
export default {
  computed: {
    isLoading() {
      return this.$store.getters['user/isLoading']
    }
  }
}
</script>

<style lang="scss">
.loader {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>